import Kithara from "src/services/kithara";
const kithara = new Kithara();

export default {
  getTemplates() {
    return kithara.getHTTP().get("/v2/templates");
  },
  getTemplate(id) {
    return kithara.getHTTP().get(`/v2/templates/${id}`);
  },
  postTemplate(template) {
    return kithara.getHTTP().post("/v2/templates", template);
  },
  putTemplate(id, template) {
    return kithara.getHTTP().put(`/v2/templates/${id}`, template);
  },
  deleteTemplate(id) {
    return kithara.getHTTP().delete("/v2/templates/" + id);
  }
};



// WEBPACK FOOTER //
// ./src/services/PlaylistTemplateService.js